import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Doughnut } from "react-chartjs-2"

//data
const getData = graphql`
  {
    c: allContentfulFiche(
      filter: { notDinaux: { eq: false }, gender: { eq: "homme" } }
    ) {
      nodes {
        name
      }
      homme: totalCount
    }
    d: allContentfulFiche(
      filter: { notDinaux: { eq: false }, gender: { eq: "femme" } }
    ) {
      nodes {
        name
      }
      femme: totalCount
    }
  }
`

const HommeFemme = () => {
  const data = useStaticQuery(getData)
  const homme = data.c.homme
  const femme = data.d.femme

  const dataStructure = {
    homme,
    femme,
  }

  const chartDataConfig = {
    labels: Object.keys(dataStructure),
    datasets: [
      {
        data: Object.values(dataStructure),
        label: "Proportions Homme/Femme",
        backgroundColor: ["#3aabeb", "#ffaaf6"],
        borderWidth: 1,
      },
    ],
  }
  console.log(Object.values(dataStructure))

  return (
    <div className="stat">
      <h2>Homme / femme Dinaux</h2>
      <Doughnut data={chartDataConfig} />
    </div>
  )
}

export default HommeFemme
